export const canShow = (role: string|null) => role && role !== 'Viewer';

const forbiddenViewerPages = ['/tags', '/site-viewers', '/configurations'];
export const canSeePage = (role: string|null, link: string) => role !== 'Viewer' || !forbiddenViewerPages.includes(link);